import type { CellContext } from "@tanstack/react-table";
import { useLocalizedData } from "contexts/LocalizationContext/hooks";

export const NumberCell = <T,>({ getValue }: CellContext<T, number>) => {
  const { getLocalizedNumber } = useLocalizedData();
  return getLocalizedNumber(Number(getValue()));
};
